import { UrbanFeatureMap } from "modules/urban-feature";
import { Wrapper } from "components/layout";

export function UrbanFeaturePage() {
  return (
    <Wrapper title="Urban Features" className="mask-background">
      <div className="relative -mt-16 map-height">
        <UrbanFeatureMap />
      </div>
    </Wrapper>
  );
}
